import React, { useMemo } from 'react';
import { useListRecentOrdersQuery } from '../../../../API/order/OrderApi';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { ITimberRecentOrderResponse } from '../../../../ui-toolkit/orders/interfaces/ITimberOrderResponse';
import { Anchor } from '@zillow/constellation';
import { clientUrls } from '../../../../ui-toolkit/rest/ClientUrlFactory';
import { DataGrid } from '../../../../ui-toolkit/components/DataGrid/DataGrid';
import { ErrorBoundaryConstellation } from '../../../../constellationExtended/ErrorBoundary/ErrorBoundaryConstellation';
import { DateFormat, getDateString } from '../../../../ui-toolkit/utilities/getDateString';

const columns: IBootstrapTableColumnProps<ITimberRecentOrderResponse>[] = [
  {
    dataField: 'fileNumber',
    text: 'Order ID',
    formatter: (_, row) => (
      <Anchor href={clientUrls.urlFor.orderStatus(row.orderId)} target={'_blank'} rel={'noreferrer noopener'}>
        {row.fileNumber}
      </Anchor>
    ),
  },
  {
    dataField: 'lastAccessedAt',
    text: 'Accessed',
    formatter: (_, row) => <>{getDateString(DateFormat.short, row.lastAccessedAt)}</>,
    sort: true,
  },
];

export const RecentOrdersTable: React.FC = () => {
  const { data: recentOrders = [], isFetching } = useListRecentOrdersQuery(undefined, {
    pollingInterval: 2 * 60_000, // every 2 minutes re-fetch the most recent orders
    refetchOnMountOrArgChange: true, // fetch whenever we mount the component
  });
  const sortedData = useMemo(() => {
    return recentOrders.toSorted((orderA, orderB) => {
      const dateA = new Date(orderA.lastAccessedAt);
      const dateB = new Date(orderB.lastAccessedAt);
      return dateB.getTime() - dateA.getTime();
    });
  }, [recentOrders]);
  return (
    <ErrorBoundaryConstellation>
      <DataGrid
        columns={columns}
        keyField={'lastAccessedAt'}
        data={sortedData}
        loading={isFetching}
        defaultSorted={[{ dataField: 'lastAccessedAt', order: 'desc' }]}
      />
    </ErrorBoundaryConstellation>
  );
};
